import type { FC } from "react";

import { Text } from "@hightouch/htui";

import { AuthLayout } from "src/components/auth/auth-layout";
import { AuthCard } from "src/components/auth/auth-card";

export const Invalid: FC = () => {
  return (
    <>
      <AuthLayout>
        <AuthCard heading="Invalid invitation" gap={8}>
          <Text>
            Check that your account email is the same as the invite recipient or
            contact your workspace administrator.
          </Text>
        </AuthCard>
      </AuthLayout>
    </>
  );
};
